import { useEffect, useEffectEvent } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { useIntersectionObserver } from '@vk-hr-tek/ui/hooks';

import { NotificationItemSkeleton } from '../NotificationItemSkeleton';

interface IntersectionNotificationItemSkeletonProps {
  onIntersect: () => void;
}

export const IntersectionNotificationItemSkeleton = ({
  onIntersect,
}: IntersectionNotificationItemSkeletonProps) => {
  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: '100px',
  });

  const onIntersectEvent = useEffectEvent(() => onIntersect());

  useEffect(() => {
    if (entry?.isIntersecting) {
      onIntersectEvent();
    }
  }, [entry?.isIntersecting]);

  return (
    <Box ref={ref}>
      <NotificationItemSkeleton />
    </Box>
  );
};
